import React from 'react';
import { Card, CardContent } from './ui/card';
import { Quote } from 'lucide-react';

const TestimonialsSection = () => {
  const testimonials = [
    {
      name: 'James Frates',
      role: 'Business Owner',
      content:
        "Microsystems Networking has been handling our IT for over two years now. They're responsive, knowledgeable, and always explain things in a way that makes sense. Our network runs smoothly and we rarely have issues anymore.",
    },
    {
      name: 'Robin Stearns',
      role: 'Operations Manager',
      content:
        'The Office 365 migration was seamless. They moved our entire team over a weekend with minimal disruption. The training they provided helped everyone get up to speed quickly. Very professional service.',
    },
    {
      name: 'Raymond Morris',
      role: 'IT Director',
      content:
        "We brought them in for a cyber assessment and they found several vulnerabilities we weren't aware of. Their report was thorough and the remediation plan was practical. Good value for the investment.",
    },
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <p className="text-sm font-semibold text-cyan-500 uppercase tracking-wide mb-2">
            Testimonials
          </p>
          <h2 className="text-4xl font-bold text-gray-900 mb-4">What Our Clients Say</h2>
          <p className="text-lg text-gray-600">Hear from businesses we have helped with their IT needs</p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <Card
              key={index}
              className="border border-gray-200 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 relative"
            >
              <CardContent className="pt-6">
                <Quote className="w-10 h-10 text-cyan-400 mb-4" />
                <p className="text-gray-600 leading-relaxed mb-6">{testimonial.content}</p>
                <div className="pt-4 border-t border-gray-100">
                  <div className="font-bold text-gray-900">{testimonial.name}</div>
                  <div className="text-sm text-gray-600">{testimonial.role}</div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;